// @flow
import apiConfig from '../../../config'; // eslint-disable-line import/no-unresolved
import { fetchUser } from '../../config/ConfigActions';
import { REQUEST_DASHBOARD_DATA, RECEIVE_DASHBOARD_DATA } from '../../ActionsConst';
import { productsEndpointRequest } from '../../../stores/ProductsMiddleware';
import apiRequest from '../../../stores/ApiService';
import { buildAndShowErrorToast } from '../../core/actions/toast/ToastActions';
import toastMsg from '../../../data/toast';

export const requestDashboardData = () => ({
  type: REQUEST_DASHBOARD_DATA,
});

export const receiveDashboardData = (user: Object, totalProducts: number, orders: Object) => ({
  type: RECEIVE_DASHBOARD_DATA,
  user,
  totalProducts,
  orders: orders.items,
});

const fetchDashboardData = (apiUrl: string): Promise<Object> =>
  new Promise((resolve, reject) => {
    fetchUser(apiUrl)
      .then((user) => {
        const requestSettings = {
          method: 'GET',
          url: 'print-products',
          ids: {},
          urlConfig: {
            sendStore: true,
          },
        };

        productsEndpointRequest(apiUrl, requestSettings, user, {
          productSize: 'ALL',
          productTypeId: 'ALL',
          template: 'ALL',
        })
          .then((response) => response.json())
          .then((products) => {
            resolve({ user, productsTotal: products.total });
          })
          .catch(reject);
      })
      .catch(reject);
  });

const fetchOrderHistory = (apiUrl: string): Promise<Object> =>
  apiRequest({
    method: 'GET',
    url: `${apiUrl}/${apiConfig.urls.orderHistoryConfiguration}?pageNumber=0&pageSize=4&sort=DATE:DESC`,
  }).then((response) => response.json());

const getDashboardData = () => {
  return (dispatch: Function, getState: Function, apiUrl: string): Promise<void> => {
    dispatch(requestDashboardData());
    return Promise.all([fetchDashboardData(apiUrl), fetchOrderHistory(apiUrl)])
      .then(([dashboardData, orders]) => {
        dispatch(receiveDashboardData(dashboardData.user, dashboardData.productsTotal, orders));
      })
      .catch(() => {
        dispatch(buildAndShowErrorToast(toastMsg.generalErrorReceivedMessage));
      });
  };
};

const dashboardActions = {
  getDashboardData,
};

export default dashboardActions;
